import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { nextPrevBtnProps } from '../types'
import RenderPrevBtn from './RenderPrevBtn.jsx'

const PrevBtnCatalog = props => (
  <StaticQuery
    query={graphql`
      query {
        allSitePage(filter: { path: { regex: "/exhibition-catalogue/" } }) {
          edges {
            node {
              path
              context {
                uid
              }
            }
          }
        }
      }
    `}
    render={data => (
      <RenderPrevBtn
        allSitePage={data.allSitePage.edges}
        currentView={props.currentView}
        paginatorOpen={props.paginatorOpen}
        base="exhibition-catalogue"
      />
    )}
  />
)

export default PrevBtnCatalog

PrevBtnCatalog.propTypes = nextPrevBtnProps
